import React, { useState, useEffect, useRef, MouseEvent } from 'react';
import Checkbox from '../Checkbox';
import ListItem, { Props as ListItemProps } from './Item';

type Props = Omit<ListItemProps, 'extra' | 'arrow'> & {
  /** 选中状态 */
  checked?: boolean;
  /**
   * 切换选中状态的回调函数
   *
   * @param {boolean} checked 选中状态
   */
  onChange?: (/** 选中状态 */ checked: boolean) => void;
};

function CheckboxItem(props: Props) {
  const { checked, onChange, ...rest } = props;
  const [currentChecked, setCurrentChecked] = useState<boolean>(
    checked || false
  );
  const checkboxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof checked === 'boolean') {
      setCurrentChecked(checked);
    }
  }, [checked]);

  /**
   * 组件自身的点击回调函数
   *
   * @param {MouseEvent<HTMLDivElement>} e
   */
  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    if (checkboxRef.current && e.target !== checkboxRef.current.parentNode) {
      // 点击 Checkbox 时会触发Checkbox自身以及冒泡到此组件的点击事件
      // 防止触发2次点击事件
      checkboxRef.current.click();
    }
  };

  /**
   * Checkbox 组件选中状态变更回调函数
   *
   * @param {boolean} val
   */
  const handleChange = (val: boolean) => {
    if (typeof checked !== 'boolean') {
      setCurrentChecked(val);
    }

    if (onChange) {
      onChange(val);
    }
  };

  return (
    <ListItem
      {...rest}
      onClick={handleClick}
      extra={
        <Checkbox
          checked={currentChecked}
          onChange={handleChange}
          ref={checkboxRef}
        />
      }
    />
  );
}

export default CheckboxItem;
